module.exports = __webpack_public_path__ + "static/media/blog.ffc59a7e.svg";